import { render, staticRenderFns } from "./subjectSet.vue?vue&type=template&id=1803c22a&"
import script from "./subjectSet.vue?vue&type=script&lang=js&"
export * from "./subjectSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports